import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["tab", "panel"]
    static classes = ["active", "inactive"]

    connect() {
        // Read tab from URL
        const params = new URLSearchParams(window.location.search)
        const tabName = params.get("tab")

        let initialIndex = 0
        this.tabTargets.forEach((tab, i) => {
            if (tab.dataset.tabName === tabName || tab.textContent.trim().toLowerCase() === tabName) {
                initialIndex = i
            }
        })

        this.showTab(initialIndex)
    }

    switch(event) {
        const index = this.tabTargets.indexOf(event.currentTarget)
        this.showTab(index)

        // Update URL without reloading based on data-tab-name or fallback
        const currentTab = this.tabTargets[index]
        const tabName = currentTab.dataset.tabName || `tab${index}`

        const url = new URL(window.location)
        url.searchParams.set("tab", tabName)
        window.history.replaceState({}, "", url)
    }

    showTab(index) {
        this.tabTargets.forEach((tab, i) => {
            if (i === index) {
                tab.classList.add(...this.activeClasses)
                tab.classList.remove(...this.inactiveClasses)
            } else {
                tab.classList.remove(...this.activeClasses)
                tab.classList.add(...this.inactiveClasses)
            }
        })

        if (this.hasPanelTarget) {
            this.panelTargets.forEach((panel, i) => {
                if (i === index) {
                    panel.classList.remove("hidden")
                } else {
                    panel.classList.add("hidden")
                }
            })
        }
    }
}
